let KEY;
let BASE_INVENTORY_URL;
let BASE_MASTERDATA_URL;
let BASE_TH_MASTERDATA_URL;
let BASE_ID_MASTERDATA_URL;
let BASE_ME_MASTERDATA_URL;
let BASE_BULK_UPLOAD;
let BASE_BULK_UPLOAD_V2;
let BASE_OMS_URL = 'https://b2c-oms.qac24svc.dev';
let GOOGLE_GEO_CODE = 'https://maps.googleapis.com/maps/api/geocode/json';
let RESOURCE_PLANNER;
let SLOT_PLANNER;
let BASE_KEY_MANAGEMENT_URL;
let BASE_REFURBISHMENT_URL;
let BASE_ADMIN_UTILS_URL;
let BASE_USER_MANAGEMENT_SYSTEM_URL;
let BASE_DSA_LMS_URL;
let BASE_FASTAG_D2C_URL;
let BASE_REFURB_GATEWAY_URL;
let BASE_ENBD_CF_URL;
const currentEnv = process.env.REACT_APP_ENV;
const country = localStorage.getItem('country');

export const dsaLmsToken =
  'YzI0X2NoYXRib3Q6WWdrUUVrMURTS2JsZXhBWGpMeU1kdDdUUXRIVkZsalk=';

const getBaseRefurbUrl = (env) => {
  switch (env) {
    case 'qa':
      return country === 'ID'
        ? 'https://refurbishment-service.qac24svc.dev'
        : 'https://refurbishment-service.qac24svc.dev';
    case 'staging':
      return country === 'ID'
        ? 'https://stage-refurbishment-service.qac24svc.dev'
        : 'https://stage-refurbishment-service.qac24svc.dev';
    case 'prod':
      return country === 'ID'
        ? 'https://refurbishment-service.c24.tech'
        : 'https://refurbishment-service.c24.tech';
    default:
      return country === 'ID'
        ? 'https://refurbishment-service.qac24svc.dev'
        : 'https://refurbishment-service.qac24svc.dev';
  }
};

switch (currentEnv) {
  case 'qa':
    BASE_INVENTORY_URL = 'https://b2c-inventory.qac24svc.dev';
    BASE_MASTERDATA_URL = 'https://b2c-masterdata.qac24svc.dev';
    BASE_TH_MASTERDATA_URL = 'https://masterdata-th.qac24svc.dev';
    BASE_ID_MASTERDATA_URL = 'https://masterdata-id.qac24svc.dev';
    BASE_ME_MASTERDATA_URL = 'https://b2c-masterdata-me.qac24svc.dev';
    KEY = 'AIzaSyDmpfxakAGCqOrkABOIGE6S4pH0aqsftDA';
    BASE_BULK_UPLOAD = 'https://bulk-upload-service.qac24svc.dev';
    BASE_OMS_URL = 'https://b2c-oms.qac24svc.dev';
    BASE_BULK_UPLOAD_V2 = 'https://bulk-upload-service-v2.qac24svc.dev';
    RESOURCE_PLANNER = 'https://resource-planner.qac24svc.dev';
    SLOT_PLANNER = 'https://slot-planner.qac24svc.dev';
    BASE_KEY_MANAGEMENT_URL = 'https://b2c-asset-management.qac24svc.dev';
    BASE_REFURBISHMENT_URL = getBaseRefurbUrl('qa');
    BASE_ADMIN_UTILS_URL = 'https://b2c-admin-utils.qac24svc.dev';
    BASE_USER_MANAGEMENT_SYSTEM_URL =
      'https://user-management-system.qac24svc.dev';
    BASE_DSA_LMS_URL = 'https://dsa-lms.qac24svc.dev';
    BASE_FASTAG_D2C_URL = 'https://b2c-gateway-india.qac24svc.dev';
    BASE_REFURB_GATEWAY_URL = 'https://refurb-app-gateway.qac24svc.dev';
    BASE_ENBD_CF_URL = 'https://b2c-uae-cf.qac24svc.dev';
    break;
  case 'staging':
    BASE_INVENTORY_URL = 'https://stage-b2c-inventory.qac24svc.dev';
    BASE_MASTERDATA_URL = 'https://stage-b2c-masterdata.qac24svc.dev';
    BASE_TH_MASTERDATA_URL = 'https://masterdata-th.qac24svc.dev';
    BASE_ID_MASTERDATA_URL = 'https://masterdata-id.qac24svc.dev';
    BASE_ME_MASTERDATA_URL = 'https://stage-b2c-masterdata-me.qac24svc.dev';
    KEY = 'AIzaSyDmpfxakAGCqOrkABOIGE6S4pH0aqsftDA';
    BASE_BULK_UPLOAD = 'https://stage-bulk-upload-service.qac24svc.dev';
    BASE_OMS_URL = 'https://stage-b2c-oms.qac24svc.dev';
    BASE_BULK_UPLOAD_V2 = 'https://stage-bulk-upload-service-v2.qac24svc.dev';
    RESOURCE_PLANNER = 'https://stage-resource-planner.qac24svc.dev';
    SLOT_PLANNER = 'https://stage-slot-planner.qac24svc.dev';
    BASE_REFURBISHMENT_URL = getBaseRefurbUrl('staging');
    BASE_KEY_MANAGEMENT_URL = 'https://stage-b2c-asset-management.qac24svc.dev';
    BASE_ADMIN_UTILS_URL = 'https://stage-b2c-admin-utils.qac24svc.dev';
    BASE_USER_MANAGEMENT_SYSTEM_URL =
      'https://user-management-system.qac24svc.dev';
    BASE_DSA_LMS_URL = 'https://dsa-lms.qac24svc.dev';
    BASE_FASTAG_D2C_URL = 'https://stage-b2c-gateway-india.qac24svc.dev';
    BASE_REFURB_GATEWAY_URL = 'https://stage-refurb-app-gateway.qac24svc.dev';
    BASE_ENBD_CF_URL = 'https://stage-b2c-uae-cf.qac24svc.dev';
    break;
  case 'prod':
    BASE_INVENTORY_URL = 'https://b2c-inventory.c24.tech';
    BASE_MASTERDATA_URL = 'https://b2c-masterdata.c24.tech';
    BASE_TH_MASTERDATA_URL = 'https://masterdata-th.c24.tech';
    BASE_ID_MASTERDATA_URL = 'https://masterdata-id.c24.tech';
    BASE_ME_MASTERDATA_URL = 'https://b2c-masterdata-me.c24.tech';
    KEY = 'AIzaSyDmpfxakAGCqOrkABOIGE6S4pH0aqsftDA';
    BASE_BULK_UPLOAD = 'https://bulk-upload-service.c24.tech';
    BASE_OMS_URL = 'https://b2c-oms.c24.tech';
    BASE_BULK_UPLOAD_V2 = 'https://bulk-upload-service-v2.c24.tech';
    RESOURCE_PLANNER = 'https://resource-planner.c24.tech';
    SLOT_PLANNER = 'https://slot-planner.c24.tech';
    BASE_KEY_MANAGEMENT_URL = 'https://b2c-asset-management.c24.tech';
    BASE_REFURBISHMENT_URL = getBaseRefurbUrl('prod');
    BASE_ADMIN_UTILS_URL = 'https://b2c-admin-utils.c24.tech';
    BASE_USER_MANAGEMENT_SYSTEM_URL = 'https://user-management-system.c24.tech';
    BASE_DSA_LMS_URL = 'https://dsa-lms.cars24.team';
    BASE_FASTAG_D2C_URL = 'https://b2c-gateway-india.c24.tech';
    BASE_REFURB_GATEWAY_URL = 'https://refurb-app-gateway.c24.tech';
    BASE_ENBD_CF_URL = 'https://b2c-uae-cf.c24.tech';
    break;
  default:
    BASE_INVENTORY_URL = 'https://b2c-inventory.qac24svc.dev';
    BASE_MASTERDATA_URL = 'https://b2c-masterdata.qac24svc.dev';
    BASE_TH_MASTERDATA_URL = 'https://masterdata-th.qac24svc.dev';
    BASE_ID_MASTERDATA_URL = 'https://masterdata-id.qac24svc.dev';
    BASE_ME_MASTERDATA_URL = 'https://b2c-masterdata-me.qac24svc.dev';
    KEY = 'AIzaSyDmpfxakAGCqOrkABOIGE6S4pH0aqsftDA';
    BASE_BULK_UPLOAD = 'https://bulk-upload-service.qac24svc.dev';
    BASE_BULK_UPLOAD_V2 = 'https://bulk-upload-service-v2.qac24svc.dev';
    RESOURCE_PLANNER = 'https://resource-planner.qac24svc.dev';
    SLOT_PLANNER = 'https://slot-planner.qac24svc.dev';
    BASE_REFURBISHMENT_URL = getBaseRefurbUrl('qa');
    BASE_KEY_MANAGEMENT_URL = 'https://b2c-asset-management.qac24svc.dev';
    BASE_ADMIN_UTILS_URL = 'https://b2c-admin-utils.qac24svc.dev';
    BASE_USER_MANAGEMENT_SYSTEM_URL =
      'https://user-management-system.qac24svc.dev';
    BASE_DSA_LMS_URL = 'https://dsa-lms.qac24svc.dev';
    BASE_FASTAG_D2C_URL = 'https://b2c-gateway-india.qac24svc.dev';
    BASE_REFURB_GATEWAY_URL = 'https://refurb-app-gateway.qac24svc.dev';
    BASE_ENBD_CF_URL = 'https://b2c-uae-cf.qac24svc.dev';
    break;
}

const BASE_INSPECTION_URL = (() => {
  const urls = {
    qa: 'https://b2c-inspection-service.qac24svc.dev',
    staging: 'https://stage-b2c-inspection-service.qac24svc.dev',
    prod: 'https://b2c-inspection-service.c24.tech',
  };
  return urls[currentEnv] || 'https://b2c-inspection-service.qac24svc.dev';
})();

export const b2cCatalogUrl = () => {
  const urls = {
    qa: 'https://car-catalog-gateway-in.qac24svc.dev',
    staging: 'https://stage-car-catalog-gateway-in.qac24svc.dev',
    prod: 'https://car-catalog-gateway-in.c24.tech',
  };
  return urls[currentEnv];
};

export const config = {
  api: {
    inventory: {
      host: BASE_INVENTORY_URL,
      bulkHost: BASE_BULK_UPLOAD,
      adminUtilsHost: BASE_ADMIN_UTILS_URL,
      api_version: '/api',
      inventory: '/inventory',
      inventoryAsset: '/inventory/asset',
      inspectionDetails: '/inspectionDetails',
      paymentStatus: '/paymentStatus',
      inventoryCount: '/count',
      auditTrail: '/audit-log',
      movement: '/movement',
      inventoryMovement: '/inventory-movement',
      logistic: '/logistic',
      config: '/config',
      price: '/price',
      publishStatus: '/publish-status',
      reserveStatus: '/reserveStatus',
      uploadCsv: '/bulk-upload-csv',
      time_slots: '/time-slots',
      exportCSV: '/export/open-movement',
      upload: '/upload',
      updateMovement: '/movement-update',
      updateMovementDetails: '/update/movement-details',
      v2: '/v2',
      type: '?type=',
      status: '/status',
      statusCount: '/status/count',
      ui_rules: '/ui-rules',
      locus_teams: '/locus/teams',
      inventoryField: '/field/inventory',
      inventoryMovementField: '/field/inventoryMovement',
      contactPersons: '/contact-person-details',
      pendingAction: '/pendingAction',
      pendingActionCount: '/count',
      pendingUpdates: '/pending-updates',
      internalMovement: '/internal-movement',
      bulk: '/bulk',
      notification: '/notification',
      nextHop: '/next-hop',
      hardRefresh: '/hard-refresh',
      order: '/order',
      updateRegNo: '/api/utility/update/registration-number',
      key: '/key',
      count: '/count',
      spareKey: '/spare-key',
      keyDetails: '/key-details',
      chassis: '/chassis',
      uploadChassis: '/upload/chassis',
      location: '/location',
      holdingPeriod: '/holding-period',
    },
    masterdata: {
      host: BASE_MASTERDATA_URL,
      host_th: BASE_TH_MASTERDATA_URL,
      host_id: BASE_ID_MASTERDATA_URL,
      host_me: BASE_ME_MASTERDATA_URL,
      api: '/api',
      api_v1: '/api/v1',
      api_v2: '/api/v2',
      masterData: '/masterdata',
      storeLocation: '/location',
      preSignedURL: '/masterdata/location/pre-signed-url/HUB_VIDEO',
      preSignedURLImage: '/masterdata/location/pre-signed-url/HUB_GALLERY',
      make: '/make',
      bulk_csv: '/bulk-csv',
      city: '/city',
      route: '/route',
      state: '/state',
      zone: '/zone',
      count: '/count',
      pricing: '/pricing',
      service: '/service',
      placeType: '?placeType=LOCATION&placeCode=',
      c2c_zone: '/c2c-zones',
      region: '/region',
      code: '/code',
      location: '/locations',
      pincodeName: '/pincode',
      pincode: '/serviceable/pincodes',
      pincodeAddEdit: '/serviceable/pincode',
      auditLog: '/audit-log',
    },
    inspection: {
      host: BASE_INSPECTION_URL,
      inspection: '/inspection',
    },
    google: {
      googleKey: KEY,
      host: GOOGLE_GEO_CODE,
      LatLng: '?latlng=',
      address: '?address=',
      last_url_api: '&key=' + KEY,
    },
    oms: {
      host: BASE_OMS_URL,
      order: '/order/',
      latest: '/latest',
    },
    bulkuploadv2: {
      baseUrl: BASE_BULK_UPLOAD_V2,
      types: '/api/upload/types',
      upload: '/api/upload',
      initiateDownload: '/api/upload/download',
      validate: '/api/upload/validate',
      metadata: '/api/metadata',
      download: '/api/metadata/download',
      count: '/api/search/count',
      search: '/api/search',
      itemcount: '/api/search/items/count',
      itemsearch: '/api/search/items',
      abort: '/api/upload/abort',
    },
    resourcePlanner: {
      baseUrl: RESOURCE_PLANNER,
      create: '/api/resource/ims',
      get: '/api/resource/ims',
    },
    slotPlanner: {
      baseUrl: SLOT_PLANNER,
    },
    keyManagement: {
      hostUrl: BASE_KEY_MANAGEMENT_URL,
      api_v1: '/api/v1',
      keyRequest: '/asset/key/request',
      outKeys: '/asset/key/outkey',
      getAllKeys: '/asset/key/request/grid?search',
      getOutKeys: '/asset/key/outkey/grid?search',
      keyAuditTrail: '/asset/key/audit/trail',
      teamStatus: '/asset/teams-status',
      updateKey: '/asset/outkey/count/update',
      assetkey: '/asset/key',
    },
    refurbishment: {
      baseUrl: BASE_REFURBISHMENT_URL,
      inspection: '/inspection',
    },
    userManagement: {
      baseUrl: BASE_ADMIN_UTILS_URL,
      umsBaseUrl: BASE_USER_MANAGEMENT_SYSTEM_URL,
      v1: '/v1',
      api_version: '/api',
      user: '/user',
      group: '/group',
      addGroup: '/addGroup',
      removeGroup: '/removeGroup',
      admin: '/admin',
      roster: '/roster',
      upload: '/upload',
      leave: '/leave',
    },
    scheduledTasks: {
      baseUrl: BASE_INVENTORY_URL,
      api_version: '/api',
      v2: '/v2',
      inventory: '/inventory',
      scheduledMovement: '/scheduled-movement',
    },
    userManagementV2: {
      baseUrl: BASE_USER_MANAGEMENT_SYSTEM_URL,
      v1: '/v1',
      user: '/user',
      activeStatus: '/active-status',
      count: '/count',
      organization: '/organization',
      group: '/group',
      uploadImage: '/upload-image',
      deleteImage: '/delete-image',
    },
    dsaLms: {
      baseUrl: BASE_DSA_LMS_URL,
      userPreferences: '/user-preferences',
      count: '/count',
    },
    fastagD2c: {
      baseUrl: BASE_FASTAG_D2C_URL,
      fastagFulfilmentOrders: '/api/v1/oms/fastag/order/admin',
      fastagFulfilmentDetails: '/api/v1/lms/fastag/fulfillment',
      viewFile: '/api/v1/document/view',
      fastagFulfilmentFile: '/api/v1/kyc/document/upload',
      fastagFulfilmentConfig: '/api/v1/lms/fastag/fulfilment/config',
      activateFastagOrder: '/api/v1/oms/fastag/order/activate',
      updateKyc: '/api/v1/kyc',
    },
    carCleaning: {
      baseUrl: BASE_REFURB_GATEWAY_URL,
      cleaningQa: '/byss/api/ops/v1/listing/CLEANING_QA',
      cleaningHistory: '/byss/api/ops/v1/listing/CLEANING_HISTORY',
      tasks: '/byss/api/ops/v1/tasks',
      trainingTutorial: '/byss/api/ops/v1/tutorial',
      getPreSignedUrl: '/refurb/api/ops/v1/pre-signed-url',
    },
    enbdRstl: {
      baseUrl: BASE_ENBD_CF_URL,
      filter: '/enbd/credit-line/filter',
      appointments: '/enbd/credit-line/appointments',
      appointmentAudit: '/enbd/credit-line/appointments',
      submitApplications: '/enbd/credit-line/submit-applications',
      releaseApplications: '/enbd/credit-line/release-applications',
      uploadLink: '/api/v1/document/internal/upload-link',
    },
  },
};

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
